import React from "react"

import useAppState from "context/hooks/useAppState"
import { usePostPrsPreview } from "api/hooks/studies/useAuthoringApi"
import { AUTHORING_TASKS } from "constants/tasks.js"

export default function useAuthoringPreviewActions() {
  const postPrsPreview = usePostPrsPreview()

  const { openToastNotification, pollingCallbackRef, pollingCallbackErrorRef, setPollingTaskId, setTaskType } =
    useAppState()
  const onDownloadPrsPdfPreview = () => {}

  const onPrsPreview = ({ authoringId, previewType, showValidations = false, formSection, callback, onSettled }) => {
    openToastNotification("info", "Loading", "Retrieving PRS Preview in progress")
    postPrsPreview(
      {
        id: `${authoringId}/prs-preview`,
        body: {
          preview_type: previewType,
          show_validations: showValidations,
          results_section:
            formSection?.id === "delayedResultsCertification" ? "delayed_results_certification" : "results",
        },
      },
      {
        onSuccess: async ({ data }) => {
          pollingCallbackRef.current = callback
          setPollingTaskId(data.task_id)
          setTaskType(AUTHORING_TASKS.prsPreview)
          pollingCallbackErrorRef.current = onSettled
        },
        onError: async (error) => {
          console.log({ error })
          onSettled()
        },
      }
    )
  }

  return {
    onDownloadPrsPdfPreview,
    onPrsPreview,
  }
}
